import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';
import DeleteButton from '../../common/components/DeleteButton';
import { PaymentTypes } from '../payments/actions';
import Card from '../../common/components/Card';
import ReduxBlockUi from 'react-block-ui/redux';
import utils from '../../common/services/utils';

const View = ({ payment, cancelSession, blockSessions, unblockSessions, enableUserTimeZone, t }) => {
	const { child, childSessions, center } = payment;

	const sessionsByWeek = utils.groupBy(childSessions, 'week');

	return <Row>
		<Col xs={12} md={4} className='pull-right'>
			<Card color='orange'>
				<h4><Link to={`/payment-history/${payment.id}/${PaymentTypes.Workshop}`} className='no-decoration'>{t('FO_Payment_Id')}{payment.id}</Link></h4>
				<h4><CenterDetailsLink center={center} /></h4>
				<h4 className='text-muted'>{payment.workshop}</h4>
				<div style={{ fontSize: 20, marginTop: 10 }}>{child && child.fullName}</div>
			</Card>
		</Col>
		<ReduxBlockUi block={blockSessions} unblock={unblockSessions}>
			{Object.keys(sessionsByWeek).map(week => {
				const sessions = sessionsByWeek[week];
				return <Col xs={12} md={8}>
					<h3>{week}</h3>
					<Table responsive className='table-expanded'>
						<tbody>
							{sessions.map(session => {
								const sessionStart = enableUserTimeZone ? utils.convertToUserTime(session.start, center) : moment(session.start);
								const sessionEnd = enableUserTimeZone ? utils.convertToUserTime(session.end, center) : moment(session.end);

								return <tr key={session.id}>
									<td>
										{sessionStart.format('dddd')}
									</td>
									<td>
										{sessionStart.format('ll')}
									</td>
									<td>
										{sessionStart.format('LT')} - {sessionEnd.format('LT')}
									</td>
									<td>
										{session.canceled && <b className='text-error'>{t('FO_ChildLesson_Canceled')}</b>}
										{session.isInTheFuture && !session.canceled && session.allowParentCancelWorkshopSession && <DeleteButton onDelete={() => cancelSession(session.id)}
											label={t('FO_ChildLesson_CannotAttend')}
											confirmationTitle={t('FO_ChildWorkshopSession_CannotAttendConfirmationTitle')}
											confirmationMessage={t('FO_ChildWorkshopSession_CannotAttendConfirmationMessage', { sessionDate: moment(session.start).format('lll') })} />}
										{!session.isInTheFuture && !session.canceled && <b>
											{session.isAttended ? <span className='text-success'>{t('FO_ChildLesson_Attended')}</span> :
												<span className='text-error'>{t('FO_ChildLesson_NotAttended')}</span>}
										</b>}
									</td>
								</tr>
							})}
						</tbody>
					</Table>
				</Col>;
			})}
		</ReduxBlockUi>
	</Row>;
};

export default withTranslation()(View);